import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/instant'

const InstantApi = {
  getAllCard (loanId, success, failure) {
    return ajax.get(
      `${BASE_URL}/lpp/all-card/get`,
      { loanId: loanId },
      success,
      failure
    )
  },
  searchDebitCard (loanId, instantFundCardId, success, failure) {
    return ajax.get(
      `${BASE_URL}/lpp/debit-card/search`,
      {
        instantFundCardId: instantFundCardId,
        loanId: loanId
      },
      success,
      failure
    )
  },
  enableDebitCard (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lpp/card/enable`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getAvailableCard (loanId, success, failure) {
    return ajax.get(
      `${BASE_URL}/lpp/available-card/get`,
      {
        loanId: loanId
      },
      success,
      failure,
      { showLoading: true }
    )
  }
}
export { InstantApi }
